module.exports = __webpack_public_path__ + "img/icon_video.cb7cc5fd.svg";